module.exports = __webpack_public_path__ + "img/arrow-down.79975099.svg";